import { render, staticRenderFns } from "./HotTags.vue?vue&type=template&id=162ea908&"
import script from "./HotTags.vue?vue&type=script&lang=js&"
export * from "./HotTags.vue?vue&type=script&lang=js&"
import style0 from "./HotTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports